module.exports = __webpack_public_path__ + "static/media/call.7b0ac869.svg";